import { useSyncExternalStore } from "react";

// Keep in sync with Tailwind's default md breakpoint.
const DESKTOP_QUERY = "(min-width: 48rem)";

function subscribe(onChange: () => void) {
  const media = window.matchMedia(DESKTOP_QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

export function useDesktopViewport() {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(DESKTOP_QUERY).matches,
    () => false,
  );
}
